// State ======================
import globalActions from "../api/GlobalActions.js";
import globalMutations from "../api/GlobalMutations.js";
import globalGetters from "../api/GlobalGetters.js";

export const state = () => ({
  type: "files",
  relations: [],
  all: {},
  reference: {},
  active: false,
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 20,
    sort: true,
    sortBy: "updated_at",
    page: 1,
    descending: true,
    sortDesc: [],
  },
  total: 0,
  print: false,
  print_path: "",
  export: false,
  search: null,
  bound: {},
  stub: {},
  filter: {},
  include: [],
  headers: {},
  notifications: {},
});

// Mutations ==================

export const mutations = {
  ...globalMutations,
};

// Actions ====================

export const actions = {
  ...globalActions,
};

// Getters ====================

export const getters = {
  ...globalGetters,
};
